const INVOICE_TYPES = [
  ["so", "SO"],
  ["transfer", "INT"],
];

export function formatInvoiceNumbers(shipmentInvoices = [], withColon = false) {
  const numbersByType = shipmentInvoices.reduce(
    (result, shipmentInvoice) => {
      const invoice = shipmentInvoice.invoice;
      if (invoice?.number) {
        const type = invoice.odooModelType === "transfer" ? "transfer" : "so";
        result[type].push(invoice.number);
      }
      return result;
    },
    { so: [], transfer: [] },
  );

  return INVOICE_TYPES.filter(([type]) => numbersByType[type].length)
    .map(
      ([type, label]) =>
        `${label}${withColon ? ":" : ""} ${numbersByType[type].join("/")}`,
    )
    .join(" · ");
}
